<template>
  <v-container fluid class="pa-8">
    <v-row align="center" justify="center">
      <v-col cols="12" class="mb-2">
        <home-current-page></home-current-page>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <h2 class="title-page">Repositório de relatórios</h2>
        <h4 class="mt-2 subtitle-page">Relatórios gerados pelo Simepar.</h4>
      </v-col>
      <v-col cols="12" class="mb-2">
        <reports-table></reports-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ReportsTable from "../../components/reports/ReportsTable";
import HomeCurrentPage from "../../components/common/HomeCurrentPage";
export default {
  name: "Reports",
  components: {HomeCurrentPage, ReportsTable}
}
</script>

<style scoped>
.title-page{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page{
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
